import { returnFormattedDate } from "@/lib/globalFormatterHelper";
import { ExecutionStrategy } from "@/lib/interfaces and Enums/InterfaceExecutionStrategy";
import { fetchRequestWrapper } from "@/lib/utilities";
import { toast } from "react-toastify";

export interface IqueryForExecutionSummaryHistorical {
  shortStartDate: string;
  shortEndDate: string;
  historicTradeDataForDataRange: ExecutionStrategy[] | [];
  viewingHistoricalTable: boolean;
}

export async function getHistoricDataViaRange(
  currentHistoricalDataSettings: IqueryForExecutionSummaryHistorical,
  setHistoricTradeDataForMainTable: Function,
  getAccessTokenSilently: Function,
  // is there a need for a flag to show that the user has tried to search for
) {
  //   const { shortStartDate, shortEndDate } = historicTradeDataForMainTable;

  const shortStartDate = currentHistoricalDataSettings.shortStartDate;
  const shortEndDate = currentHistoricalDataSettings.shortEndDate;

  // use the start and end date to make calls.

  const historicTradeDataForDataRange: ExecutionStrategy[] =
    await fetchRequestWrapper(
      {
        url: `/Trade/Execution/Summary/${shortStartDate}/${shortEndDate}`,
        method: "GET",
      },
      getAccessTokenSilently,
    );

  if (historicTradeDataForDataRange) {
    currentHistoricalDataSettings.historicTradeDataForDataRange =
      historicTradeDataForDataRange;
    currentHistoricalDataSettings.viewingHistoricalTable = true;
    setHistoricTradeDataForMainTable(currentHistoricalDataSettings);

    if (
      currentHistoricalDataSettings.historicTradeDataForDataRange.length > 0
    ) {
      toast(
        `${currentHistoricalDataSettings.historicTradeDataForDataRange.length} Trades found for dates ${returnFormattedDate(shortStartDate)} to ${returnFormattedDate(shortEndDate)}`,
      );
    } else {
      toast(
        `No trades found for dates ${returnFormattedDate(shortStartDate)} to ${returnFormattedDate(shortEndDate)}.`,
      );
    }
    return;
  }
  currentHistoricalDataSettings.historicTradeDataForDataRange = [];
  // If there is no data found, set to an empty value.
  setHistoricTradeDataForMainTable(currentHistoricalDataSettings);
  return;
}

export async function bulkSaveUnwindBlockValuesToDatabase(
  esid: string,
  blockIds: number[],
  getAccessTokenSilently: Function,
  field: "npv" | "recoupon",
  checkedEventValue: boolean,
) {
  let unwindValueToSend: string | null = null;

  if (field === "npv" && checkedEventValue === true) {
    unwindValueToSend = "NPV";
  } else if (field === "recoupon" && checkedEventValue === true) {
    unwindValueToSend = "Recoupon";
  }

  const objToSend = {
    esid: esid,
    blocks: blockIds.map((blockId) => ({
      blockId: blockId,
      unwind: unwindValueToSend,
    })),
  };

  const saveUnwindBlockResponse = await fetchRequestWrapper(
    {
      url: "/Trade/Execution/Edit/Unwind",
      method: "PATCH",
      objToSend: objToSend,
    },
    getAccessTokenSilently,
  );

  const displayField = field == "npv" ? "NPV" : "Recoupon";

  if (saveUnwindBlockResponse) {
    toast.success(`Updating all blocks ${displayField} state for ${esid}.`);
  } else {
    toast.error(
      "An error has occured updating the unwind value of the blocks.",
    );
  }
}

export async function saveUnwindBlockValuesToDatabase(
  params: any,
  fullTradeData: ExecutionStrategy,
  getAccessTokenSilently: Function,
  field: string,
  checkedEventValue: boolean,
  // setCheckedValue,
  // unwindValue,
  // setUnwindValue,
) {
  const blockId = params.data.id;
  const esid = fullTradeData.esid;

  let unwindValueToSend = null;

  if (field == "npv" && checkedEventValue == true) {
    unwindValueToSend = "NPV";
  } else if (field == "recoupon" && checkedEventValue == true) {
    unwindValueToSend = "Recoupon";
  } else {
    unwindValueToSend = null;
  }

  const objToSend = {
    esid: esid,
    blocks: [{ blockId: blockId, unwind: unwindValueToSend }],
  };

  const saveUnwindBlockResponse = await fetchRequestWrapper(
    {
      url: "/Trade/Execution/Edit/Unwind",
      method: "PATCH",
      objToSend: objToSend,
    },
    getAccessTokenSilently,
  );

  const displayField = field == "npv" ? "NPV" : "Recoupon";

  if (saveUnwindBlockResponse) {
    toast.success(`Updating ${displayField} state.`);
  } else {
    toast.error("An error has occured updating the unwind value of the block.");
  }
}

export async function sendCouponValuesToDatabase(
  params: any,
  esid: string,
  getAccessTokenSilently: Function,
) {
  if (params.oldValue == params.newValue) {
    return;
  }

  const blockId = params.data.id;
  const coupon = params.newValue;

  const objToSend = {
    esid: esid,
    blockId: blockId,
    coupon: coupon,
    // executionRequestId: null, -- Not sure how this would get accessed as the Execution Requests are empty.
    // deliveryDate: null, -- no longer requierd.
    // dealtStrike: null, -- no longer requierd.
  };
  const saveCouponResponse = await fetchRequestWrapper(
    {
      url: "/Trade/Execution/Edit/Security",
      method: "PATCH",
      objToSend: objToSend,
    },
    getAccessTokenSilently,
  );
  if (saveCouponResponse) {
    return saveCouponResponse;
  }
}

// export async function saveCreationBlockValuesToDatabase(
//   params: NewValueParams,
//   getAccessTokenSilently: Function,
// ) {
//   const blockIdToSave = params.data.id;
//   const effectiveDateToSave = params.data.effectiveDate;
//   const newIssueToSave = params.data.newIssue;

//   if (
//     params.newValue == params.oldValue &&
//     params.colDef.cellDataType == "dateString"
//   ) {
//     toast("Enter a date, field cannot be empty");
//     return;
//   }

//   const objToSend = {
//     id: blockIdToSave,
//     effectiveDate: effectiveDateToSave,
//     newIssue: newIssueToSave,
//   };

//   const saveBlockResponse = await fetchRequestWrapper(
//     { url: "/Blocks/Unassigned", method: "PUT", objToSend: objToSend },
//     getAccessTokenSilently,
//   );

//   if (saveBlockResponse) {
//     const testNode = params.api.getRowNode(params.data.id);
//     params.api.flashCells({ rowNodes: [testNode!] });

//     if (params.newValue == params.data.effectiveDate) {
//       toast("Settlement Date updated");
//     } else if (params.newValue == params.data.newIssue) {
//       toast("New Issue Flag updated");
//     } else {
//       toast("Block changes saved");
//     }
//   }
// }
